export default [
    {
        path: '/entrega-itens', component: () => import('./components/Page'), name: 'leilao.entrega.itens.page', children: [
            {path: '', component: () => import('./components/List'), name: 'leilao.entrega.itens'},
            {path: ':id', component: () => import('./components/Show'), name: 'leilao.entrega.itens.show'},
        ]
    }
]
